<!-- 嵌入式-维修受理、初检 -->
<template>
  <el-card style="position: relative; z-index: 0; width: 100%">
    <el-tabs v-model="activeTab" @tab-click="changeTab">
      <el-tab-pane
        :label="'维修受理(' + acceptPager.total + ')'"
        name="tabAccept"
      >
        <div class="top">
          <el-input
            v-model.trim="acceptKey"
            placeholder="名称、SN或送修来源"
            @keydown.enter.native="onAcceptSubmitQuery"
            style="width: 200px"
          >
          </el-input
          >&nbsp;
          <el-select
            v-model="acceptformer.Type"
            clearable
            placeholder="维修类型"
          >
            <el-option label="产品" :value="0"></el-option>
            <el-option label="配件" :value="1"></el-option> </el-select
          >&nbsp;
          <select2
            labelName="Name"
            v-model="acceptformer.DealPeopleID"
            url="user"
            clearable
            placeholder="处理人"
            no-data-text="没有处理人"
          ></select2
          >&nbsp;
          <select2
            labelName="Value"
            valueKey="Key"
            v-model="acceptformer.DealStatus"
            url="dci/maintain/status-list"
            clearable
            placeholder="维修状态"
            no-data-text="没有维修状态"
            :currentList="curAcceptStatus"
          ></select2
          >&nbsp;
          <el-button type="primary" @click="onAcceptSubmitQuery">
            <i class="fas fa-search"></i>
          </el-button>
        </div>
        <el-table
          :data="acceptItemList"
          v-loading="acceptLoading"
          size="medium"
        >
          <el-table-column
            type="index"
            :index="acceptPager.size * (acceptPager.page - 1) + 1"
            :width="
              Math.max(
                40,
                (acceptPager.size * acceptPager.page).toString().length * 12
              )
            "
          />
          <el-table-column label="类型" width="70">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.Type === 0" type="warning"> 产品 </el-tag>
              <el-tag v-if="scope.row.Type === 1" type="success"> 配件 </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="产品/配件型号名称" width="200" >
            <template slot-scope="scope">
              <div v-if="scope.row.DciProduct !== null">
                {{ scope.row.DciProduct.DciProductModel.NameNumber }}
              </div>
              <div v-if="scope.row.DciAccessory !== null">
                {{ scope.row.DciAccessory.DciAccessoryModel.NameNumber }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="产品/配件SN" width="190">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.DciProduct !== null">
                {{ scope.row.DciProduct.SN }}
              </el-tag>
              <el-tag type="success" v-if="scope.row.DciProduct !== null && scope.row.DciProduct.Remark !== ''">
                {{ scope.row.DciProduct.Remark }}
              </el-tag> 
              <el-tag v-if="scope.row.DciAccessory !== null">
                {{ scope.row.DciAccessory.SN }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="SendSource" label="送修来源" />
          <el-table-column label="送修日期" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.SendAt">
                {{ $sys.dateFormat(scope.row.SendAt, "Y-m-d") }}
              </div>
            </template>
          </el-table-column>
          <el-table-column width="140">
            <template slot="header" slot-scope="scope">
              <div
                style="
                  padding-left: 0px;
                  padding-right: 0px;
                  line-height: normal;
                "
              >
                期望初检完成日期
              </div>
              <div
                style="
                  padding-left: 0px;
                  padding-right: 0px;
                  line-height: normal;
                  margin-top: -5px;
                "
              >
                期望维修完成日期
              </div>
            </template>
            <template slot-scope="scope">
              <div
                v-if="
                  scope.row.ExpectedInspectAt &&
                  new Date(scope.row.ExpectedInspectAt).getTime() <=
                    new Date(new Date()).getTime() &&
                  (scope.row.DealStatus === 0 ||
                    scope.row.DealStatus === 1 ||
                    scope.row.DealStatus === 2)
                "
                style="color: red"
              >
                {{ $sys.dateFormat(scope.row.ExpectedInspectAt, "Y-m-d H:i") }}
              </div>
              <div v-else-if="scope.row.ExpectedInspectAt">
                {{ $sys.dateFormat(scope.row.ExpectedInspectAt, "Y-m-d H:i") }}
              </div>
              <div
                v-if="
                  scope.row.ExpectedDealAt &&
                  new Date(scope.row.ExpectedDealAt).getTime() <=
                    new Date(new Date()).getTime() &&
                  scope.row.DealStatus !== 6
                "
                style="color: red"
              >
                {{ $sys.dateFormat(scope.row.ExpectedDealAt, "Y-m-d H:i") }}
              </div>
              <div v-else-if="scope.row.ExpectedDealAt">
                {{ $sys.dateFormat(scope.row.ExpectedDealAt, "Y-m-d H:i") }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="更换方式" width="90">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.ReplacementMode === 0" type="warning">
                不更换
              </el-tag>
              <el-tag v-if="scope.row.ReplacementMode === 1" type="primary">
                更换配件
              </el-tag>
              <el-tag v-if="scope.row.ReplacementMode === 2" type="info">
                更换整机
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="DealPeople.Name" label="处理人" width="70" />
          <el-table-column prop="DealStatusName" label="维修状态" width="105">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.DealStatus === 1" type="warning">
                {{ scope.row.DealStatusName }}
              </el-tag>
              <el-tag v-else type="success">
                {{ scope.row.DealStatusName }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column width="140" label="操作">
            <template slot-scope="scope">
              <el-button
                type="button"
                @click.stop="onAcceptDetailItem(scope.row)"
                title="详情"
              >
                <i class="fas fa-eye"></i>
              </el-button>
              <el-button
                type="primary"
                @click.stop="onAcceptClick(scope.row)"
                title="受理"
                v-if="scope.row.DealStatus === 1"
              >
                <i class="fas fa-edit"></i>
              </el-button>
              <el-button
                type="danger"
                @click.stop="onBackClick(scope.row)"
                title="退回"
                v-if="scope.row.DealStatus === 1"
              >
                <i class="fas fa-share-square"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="clearfix mar-top-10">
          <el-pagination
            class="pull-right"
            @current-change="onAcceptChangePage"
            layout="total, prev, pager, next"
            :total="acceptPager.total"
            :current-page="acceptPager.page"
            :page-size="acceptPager.size"
          >
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane
        :label="'维修初检(' + inspectPager.total + ')'"
        name="tabInspect"
      >
        <div class="top">
          <el-input
            v-model.trim="inspectKey"
            placeholder="名称、SN或送修来源"
            @keydown.enter.native="onInspectSubmitQuery"
            style="width: 200px"
          >
          </el-input
          >&nbsp;
          <el-select
            v-model="inspectformer.Type"
            clearable
            placeholder="维修类型"
          >
            <el-option label="产品" :value="0"></el-option>
            <el-option label="配件" :value="1"></el-option> </el-select
          >&nbsp;
          <select2
            labelName="Name"
            v-model="inspectformer.DealPeopleID"
            url="user"
            clearable
            placeholder="处理人"
            no-data-text="没有处理人"
          ></select2
          >&nbsp;
          <select2
            labelName="Value"
            valueKey="Key"
            v-model="inspectformer.DealStatus"
            url="dci/maintain/status-list"
            clearable
            placeholder="维修状态"
            no-data-text="没有维修状态"
            :currentList="curInspectStatus"
          ></select2
          >&nbsp;
          <el-button type="primary" @click="onInspectSubmitQuery">
            <i class="fas fa-search"></i>
          </el-button>
        </div>
        <el-table
          :data="inspectItemList"
          v-loading="inspectLoading"
          size="medium"
        >
          <el-table-column
            type="index"
            :index="inspectPager.size * (inspectPager.page - 1) + 1"
            :width="
              Math.max(
                40,
                (inspectPager.size * inspectPager.page).toString().length * 12
              )
            "
          />
          <el-table-column label="类型" width="70">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.Type === 0" type="warning"> 产品 </el-tag>
              <el-tag v-if="scope.row.Type === 1" type="success"> 配件 </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="产品/配件型号名称" width="200" >
            <template slot-scope="scope">
              <div v-if="scope.row.DciProduct !== null">
                {{ scope.row.DciProduct.DciProductModel.NameNumber }}
              </div>
              <div v-if="scope.row.DciAccessory !== null">
                {{ scope.row.DciAccessory.DciAccessoryModel.NameNumber }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="产品/配件SN" width="190">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.DciProduct !== null">
                {{ scope.row.DciProduct.SN }}
              </el-tag>
              <el-tag type="success" v-if="scope.row.DciProduct !== null && scope.row.DciProduct.Remark !== ''">
                {{ scope.row.DciProduct.Remark }}
              </el-tag> 
              <el-tag v-if="scope.row.DciAccessory !== null">
                {{ scope.row.DciAccessory.SN }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="SendSource" label="送修来源" />
          <el-table-column label="送修日期" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.SendAt">
                {{ $sys.dateFormat(scope.row.SendAt, "Y-m-d") }}
              </div>
            </template>
          </el-table-column>
          <el-table-column width="140">
            <template slot="header" slot-scope="scope">
              <div
                style="
                  padding-left: 0px;
                  padding-right: 0px;
                  line-height: normal;
                "
              >
                期望初检完成日期
              </div>
              <div
                style="
                  padding-left: 0px;
                  padding-right: 0px;
                  line-height: normal;
                  margin-top: -5px;
                "
              >
                期望维修完成日期
              </div>
            </template>
            <template slot-scope="scope">
              <div
                v-if="
                  scope.row.ExpectedInspectAt &&
                  new Date(scope.row.ExpectedInspectAt).getTime() <=
                    new Date(new Date()).getTime() &&
                  (scope.row.DealStatus === 0 ||
                    scope.row.DealStatus === 1 ||
                    scope.row.DealStatus === 2)
                "
                style="color: red"
              >
                {{ $sys.dateFormat(scope.row.ExpectedInspectAt, "Y-m-d H:i") }}
              </div>
              <div v-else-if="scope.row.ExpectedInspectAt">
                {{ $sys.dateFormat(scope.row.ExpectedInspectAt, "Y-m-d H:i") }}
              </div>
              <div
                v-if="
                  scope.row.ExpectedDealAt &&
                  new Date(scope.row.ExpectedDealAt).getTime() <=
                    new Date(new Date()).getTime() &&
                  scope.row.DealStatus !== 6
                "
                style="color: red"
              >
                {{ $sys.dateFormat(scope.row.ExpectedDealAt, "Y-m-d H:i") }}
              </div>
              <div v-else-if="scope.row.ExpectedDealAt">
                {{ $sys.dateFormat(scope.row.ExpectedDealAt, "Y-m-d H:i") }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="更换方式" width="90">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.ReplacementMode === 0" type="warning">
                不更换
              </el-tag>
              <el-tag v-if="scope.row.ReplacementMode === 1" type="primary">
                更换配件
              </el-tag>
              <el-tag v-if="scope.row.ReplacementMode === 2" type="info">
                更换整机
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="DealPeople.Name" label="处理人" width="70" />
          <el-table-column prop="DealStatusName" label="维修状态" width="105">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.DealStatus === 2" type="warning">
                {{ scope.row.DealStatusName }}
              </el-tag>
              <el-tag v-else type="success">
                {{ scope.row.DealStatusName }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column width="140" label="操作">
            <template slot-scope="scope">
              <el-button
                type="button"
                @click.stop="onAcceptDetailItem(scope.row)"
                title="详情"
              >
                <i class="fas fa-eye"></i>
              </el-button>
              <el-button
                type="primary"
                @click.stop="onInspectItem(scope.row)"
                title="初检"
                v-if="scope.row.DealStatus === 2"
              >
                <i class="fas fa-wrench"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="clearfix mar-top-10">
          <el-pagination
            class="pull-right"
            @current-change="onInspectChangePage"
            layout="total, prev, pager, next"
            :total="inspectPager.total"
            :current-page="inspectPager.page"
            :page-size="inspectPager.size"
          >
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      title="确认受理"
      :visible.sync="acceptVisible"
      :close-on-click-modal="false"
      @close="onCloseAccept"
      append-to-body
      width="40%"
    >
      <el-form
        ref="acceptItemForm"
        label-width="100px"
        :model="doAcceptItem"
        :rules="doAcceptRules"
      >
        <el-form-item label="处理人" prop="DealPeopleID">
          <select2
            style="width: 100%"
            labelName="Name"
            v-model="doAcceptItem.DealPeopleID"
            url="user"
            :clearable="false"
            placeholder="请选择处理人"
            no-data-text="没有用户"
          ></select2>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onCloseAccept">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button type="primary" @click="onAcceptItem">
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="退回维修登记"
      :visible.sync="backVisible"
      :close-on-click-modal="false"
      append-to-body
      @close="onCloseBack"
      width="40%"
    >
      <el-form
        ref="backItemForm"
        label-width="100px"
        :model="backItem"
        :rules="backRules"
      >
        <el-form-item label="退回原因" prop="BackDesc">
          <el-input
            v-model.trim="backItem.BackDesc"
            :autosize="{ minRows: 5 }"
            type="textarea"
            placeholder="请输入退回原因"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onCloseBack">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button type="primary" @click="onBackItem">
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>

    <accept-detail-form
      v-model="AcceptItem"
      :visible.sync="acceptDeltailVisible"
    />
    <inspect-detail-form
      v-model="InspectItem"
      :visible.sync="inspectDeltailVisible"
    />

    <inspect-form
      v-model="doInspectItem"
      :visible.sync="inspectVisible"
      @form:saved="getInspectItemList"
    />
  </el-card>
</template>

<script>
import InspectForm from "./inspectForm.vue";
import AcceptDetailForm from "../maintainRegister/detail.vue"; //使用维修登记中的维修详情，公用
import InspectDetailForm from "../maintainRegister/detail.vue"; //使用维修登记中的维修详情，公用

export default {
  components: {
    InspectForm,
    AcceptDetailForm,
    InspectDetailForm,
  },
  data() {
    return {
      activeTab: "tabAccept",
      acceptItemList: [],
      inspectItemList: [],
      acceptLoading: false,
      inspectLoading: false,
      acceptPager: {
        total: 0,
        page: 1,
        size: 15,
      },
      inspectPager: {
        total: 0,
        page: 1,
        size: 15,
      },
      acceptformer: {
        Type: "",
        DealPeopleID: "",
        DealStatus: "",
      },
      inspectformer: {
        Type: "",
        DealPeopleID: "",
        DealStatus: "",
      },
      backItem: {
        ID: "",
        BackDesc: "",
      },
      backRules: {
        BackDesc: [
          { required: true, message: "退回原因不能为空", trigger: "blur" },
        ],
      },
      doAcceptItem: {
        ID: "",
        DealPeopleID: "",
      },
      doAcceptRules: {
        DealPeopleID: [
          { required: true, message: "处理人不能为空", trigger: "blur" },
        ],
      },
      acceptKey: "",
      inspectKey: "",
      AcceptItem: this.getAcceptEmptyItem(),
      InspectItem: this.getInspectEmptyItem(),
      doInspectItem: this.getEmptyInspectItem(),
      inspectVisible: false,
      acceptDeltailVisible: false,
      inspectDeltailVisible: false,
      backVisible: false,
      acceptVisible: false,
      curAcceptStatus: [],
      curInspectStatus: [],
    };
  },
  mounted() {
    this.getAcceptItemList();
    this.getInspectItemList();
  },
  created() {
    this.activeTab = "tabAccept";
    this.curAcceptStatus = [
      {
        Key: 1,
        Value: "待受理",
      },
    ];
    this.curInspectStatus = [
      {
        Key: 2,
        Value: "初检中",
      },
    ];
  },
  methods: {
    // 切换选项卡
    changeTab(tab) {
      if (tab.name === "tabInspect") {
        this.inspectKey = "";
        this.inspectformer.Type = "";
        this.inspectformer.DealPeopleID = "";
        this.inspectformer.DealStatus = 2;
        // this.getInspectItemList();
      }
    },
    getAcceptItemList() {
      this.acceptLoading = true;
      this.$axios
        .get("dci/maintain/accept", {
          params: {
            where: this.acceptformer,
            with: [
              "DciProduct.DciProductModel",
              "DciAccessory.DciAccessoryModel",
              "MaintainUser",
              "SendPeople",
              "DealPeople",
            ],
            ...this.acceptPager,
            key: this.acceptKey,
            order: ["deal_status", "-send_at"],
          },
        })
        .then((response) => {
          this.acceptItemList = response.data.data;
          this.acceptPager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.acceptLoading = false;
        });
    },
    getInspectItemList() {
      this.inspectLoading = true;
      this.$axios
        .get("dci/maintain/accept", {
          params: {
            where: this.inspectformer,
            with: [
              "DciProduct.DciProductModel",
              "DciAccessory.DciAccessoryModel",
              "MaintainUser",
              "SendPeople",
              "DealPeople",
            ],
            ...this.inspectPager,
            key: this.inspectKey,
            order: ["deal_status", "-send_at"],
          },
        })
        .then((response) => {
          this.inspectItemList = response.data.data;
          this.inspectPager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.inspectLoading = false;
        });
    },
    //确认初检
    onInspectItem(row) {
      this.doInspectItem = this.getEmptyInspectItem();
      this.doInspectItem = row;
      // this.doInspectItem.ID = row.ID;
      // this.doInspectItem.Type = row.Type;
      this.inspectVisible = true;
    },
    //维修详情
    onAcceptDetailItem(row) {
      this.AcceptItem = row;
      this.acceptDeltailVisible = true;
    },
    //维修详情
    onInspectDetailItem(row) {
      this.InspectItem = row;
      this.inspectDeltailVisible = true;
    },
    getAcceptEmptyItem() {
      return {};
    },
    getInspectEmptyItem() {
      return {};
    },
    getEmptyInspectItem() {
      return {
        ID: "", //维修id
        Type: 0, //维修类型
        InspectionItems: "", //检验项目
        MaintainUserID: this.$store.state.Auth.user.ID, //维修人员
        ReasonAnalyse: "", //原因分析
        InspectionConclusion: "", //检验结论
        Grade: "", //不合格等级
        MaintainScheme: "", //维修方案
        ReplacementMode: 0, //更换方式 0:不更换 1:更换配件 2:更换整机
      };
    },
    onAcceptSubmitQuery() {
      this.acceptPager.page = 1;
      this.getAcceptItemList();
    },
    onInspectSubmitQuery() {
      this.inspectPager.page = 1;
      this.getInspectItemList();
    },
    onAcceptChangePage(page) {
      this.acceptPager.page = page;
      this.getAcceptItemList();
    },
    onInspectChangePage(page) {
      this.inspectPager.page = page;
      this.getInspectItemList();
    },

    onAcceptClick(row) {
      this.acceptVisible = true;
      this.doAcceptItem.ID = row.ID;
      this.doAcceptItem.DealPeopleID = this.$store.state.Auth.user.ID;
    },
    onCloseAccept() {
      this.acceptVisible = false;
      this.$refs.acceptItemForm.resetFields();
    },
    //确认受理
    onAcceptItem() {
      this.$refs.acceptItemForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$axios
          .request({
            url: "dci/maintain/accept",
            method: "post",
            data: this.doAcceptItem,
          })
          .then(() => {
            this.getAcceptItemList();
            this.getInspectItemList();
            this.$message.success("受理成功");
            this.acceptVisible = false;
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
          });
      });
    },

    onBackClick(row) {
      this.backVisible = true;
      this.backItem.ID = row.ID;
    },
    onCloseBack() {
      this.backVisible = false;
      this.$refs.backItemForm.resetFields();
    },
    //退回维修登记
    onBackItem() {
      this.$refs.backItemForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$axios
          .request({
            url: "dci/maintain/accept-back",
            method: "post",
            data: this.backItem,
          })
          .then(() => {
            this.getAcceptItemList();
            this.$message.success("退回成功");
            this.backVisible = false;
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.top {
  text-align: right;
  background-color: #f5f7fa;
  height: 30px;
  padding: 35px 30px 10px 30px;
  margin: -20px -20px 10px -20px;
}
</style>